import { Swiper, Pagination } from 'swiper';

const footerAdvSlider = new Swiper(".js-advantages", {
  speed: 300,
  autoHeight: true,
  simulateTouch: false,
  modules: [Pagination],
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      allowTouchMove: true,
      spaceBetween: 0,
    },
    1024: {
      slidesPerView: 4,
      allowTouchMove: true,
      spaceBetween: 30,
    },
  },
});

